import React from 'react';
import { FindingCard } from './FindingCard';
import { Finding, ResolveState, Version } from './types';
import { VERSIONS } from './data';
interface FindingsTabProps {
  version: Version;
  isReviewer: boolean;
  resolveStates: Record<string, ResolveState>;
  onResolve: (id: string, state: ResolveState) => void;
  expandedFinding: string | null;
  onExpandFinding: (id: string | null) => void;
  currentUser: string;
}
export function FindingsTab({
  version,
  isReviewer,
  resolveStates,
  onResolve,
  expandedFinding,
  onExpandFinding,
  currentUser
}: FindingsTabProps) {
  const fixedBlockers = VERSIONS[0].blockers.filter((b: Finding) => !version.blockers.find((vb: Finding) => vb.id === b.id));
  return <div style={{
    padding: '12px 16px'
  }} data-id="element-111">
      {/* Fixed Blockers */}
      {fixedBlockers.length > 0 && <div style={{
      marginBottom: 16
    }} data-id="element-112">
          <div style={{
        fontSize: 9,
        fontWeight: 800,
        color: '#2D7A6E',
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
        marginBottom: 6
      }} data-id="element-113">
            ✓ Fixed — {fixedBlockers.length}
          </div>
          {fixedBlockers.map((f: Finding) => <FindingCard key={f.id} f={f} isBlocker isFixed isReviewer={isReviewer} resolveState={null} onResolve={() => {}} expanded={false} onExpand={() => {}} currentUser={currentUser} data-id="element-114" />)}
        </div>}

      {/* Active Blockers */}
      {version.blockers.length > 0 && <div style={{
      marginBottom: 16
    }} data-id="element-115">
          <div style={{
        fontSize: 9,
        fontWeight: 800,
        color: '#B44D4D',
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
        marginBottom: 6
      }} data-id="element-116">
            ● Must Fix
          </div>
          {version.blockers.map((f: Finding) => <FindingCard key={f.id} f={f} isBlocker isFixed={false} isReviewer={isReviewer} resolveState={resolveStates[f.id] || null} onResolve={s => onResolve(f.id, s)} expanded={expandedFinding === f.id} onExpand={onExpandFinding} currentUser={currentUser} data-id="element-117" />)}
        </div>}

      {/* Suggestions */}
      {version.suggestions.length > 0 && <div style={{
      marginBottom: 16
    }} data-id="element-118">
          <div style={{
        fontSize: 9,
        fontWeight: 800,
        color: '#8896A6',
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
        marginBottom: 6
      }} data-id="element-119">
            ○ Not blockers — compliance will also check —{' '}
            {version.suggestions.length}
          </div>
          {version.suggestions.map((f: Finding) => <FindingCard key={f.id} f={f} isBlocker={false} isFixed={false} isReviewer={isReviewer} resolveState={resolveStates[f.id] || null} onResolve={s => onResolve(f.id, s)} expanded={expandedFinding === f.id} onExpand={onExpandFinding} currentUser={currentUser} data-id="element-120" />)}
        </div>}

      {/* Passed Count */}
      <div style={{
      padding: '8px 10px',
      background: '#F7FDF9',
      border: '1px solid #D1FAE5',
      borderRadius: 6
    }} data-id="element-121">
        <span style={{
        fontSize: 9,
        fontWeight: 800,
        color: '#2D7A6E',
        textTransform: 'uppercase'
      }} data-id="element-122">
          ✓ {version.passed} Passed
        </span>
      </div>
    </div>;
}